<app-form-page [config]="config"></app-form-page>

@if (config.mode === 'list') {
    <div style="padding:20px; width:calc(100%-40px)">
        <div style="display: flex; width: 100%">
            <div style="flex: 0 0 auto">
                @if (checkedAccess < 2) {
                    <mat-spinner></mat-spinner>
                } @else {
                    <button mat-raised-button color="primary" (click)="checkAccesses()">
                        <mat-icon>data_check</mat-icon>Check Access</button>
                }
            </div>
            <div style="flex:1; text-align:center">
                {{linkedBanks}} of your {{totalBanks}} Bank Accounts have been linked
            </div>
            <div style="flex: 0 0 auto">
                <button mat-raised-button color="primary" (click)="linkBank()">
                    <mat-icon>link</mat-icon>Link Bank Account</button>
            </div>
        </div>
        @if (gocAccesses.length > 0) {
            <ng-container *ngTemplateOutlet="gocAccessTemplate"></ng-container>
        }
        @if (yapilyConsents.length > 0) {
            <ng-container *ngTemplateOutlet="yapilyConsentsTemplate"></ng-container>
        }        
    </div>
}

<ng-template #gocOneAccessTemplate let-goca="goca">
    <tr class="access">
        <td [attr.rowspan]="goca.accounts.length + 1">
            <button mat-icon-button (click)="removeAccess(goca)"><mat-icon color="warn">delete</mat-icon></button>
        </td>
        <td [attr.rowspan]="goca.accounts.length + 1">{{goca.bankName}}</td>
        <td [attr.rowspan]="goca.accounts.length + 1">{{goca.created | GmtAgo}}</td>
        <td [attr.rowspan]="goca.accounts.length + 1">{{goca.status}}</td>
        <td [attr.rowspan]="goca.accounts.length + 1">
            <button mat-icon-button (click)="refreshAccess(goca)" color="primary"
            matTooltip="Connect to bank to refresh authorization to access bank information. Authorization only lasts 90 days, needs to be refreshed using this button to continue access">
                <mat-icon>cached</mat-icon>
            </button>
        </td>
        <td [attr.rowspan]="goca.accounts.length + 1">
            <button mat-icon-button (click)="testAccess(goca)" color="primary"
            matTooltip="Test the connection to the bank account">
                <mat-icon>quiz</mat-icon>
            </button>
        </td>
    </tr>
    @for (gocacct of goca.accounts; track $index) {
        <ng-container [ngTemplateOutlet]="gocAccountTemplate" [ngTemplateOutletContext]="{gocacct}"></ng-container>
    }
</ng-template>

<ng-template #gocAccountTemplate let-gocacct="gocacct">
    <tr class="access">
        <td [matTooltip]="gocacct.created">{{gocacct.created | GmtAgo}}</td>
        <td  [matTooltip]="gocacct.last_accessed">{{gocacct.last_accessed | GmtAgo}}</td>
        <td>{{gocacct.status}}</td>
        <td>{{gocacct.iban}}</td>
        <td>
            @if (gocacct.matched && gocacct.active) {
                <mat-icon color="primary"
                matTooltip="This is the active approval, if you delete it, the account will no longer be linked">done</mat-icon>
            } @else if (gocacct.matched){
                <mat-icon color="accent"
                matTooltip="There has been a fresh approval that replaces this one for this account">history</mat-icon>
            } @else {
                <mat-icon color="warn" [matTooltip]="unLinked">close</mat-icon>
            }
        </td>
    </tr>
</ng-template>

<ng-template #gocAccessTemplate>
    <h3 style="margin-top: 10px; margin-bottom: 0px; text-align:center">
        Account Access Granted (needs to be refreshed every 90 days)
    </h3>
    <table style="width:100%">
        <tr class="access">
            <th></th>
            <th>Bank Name</th>
            <th>Created</th>
            <th>Status</th>
            <th>Reapprove</th>
            <th>Test</th>
            <th>Created</th>
            <th>Accessed</th>
            <th>Status</th>
            <th></th>
            <th></th>
        </tr>
        @for (goca of gocAccesses; track $index) {
            <ng-container [ngTemplateOutlet]="gocOneAccessTemplate" [ngTemplateOutletContext]="{goca}"></ng-container>
        }
    </table>
</ng-template>

<ng-template #yapilyConsentsTemplate>
    <h3 style="margin-top: 10px; margin-bottom: 0px; text-align:center">
        Account Access Granted (needs to be refreshed every 90 days)
    </h3>
    <table style="width:100%">
        <tr class="access">
            <th></th>
            <th>Bank Name</th>
            <th>Created</th>
            <th>Status</th>
            <th>Reapprove</th>
            <th>Test</th>
            <th>Created</th>
            <th>Accessed</th>
            <th>Status</th>
            <th></th>
            <th></th>
        </tr>
        @for (yap of yapilyConsents; track $index) {
            <ng-container [ngTemplateOutlet]="yapilyConsentTemplate" [ngTemplateOutletContext]="{yap}"></ng-container>
        }
    </table>
</ng-template>

<ng-template #yapilyConsentTemplate let-yap="yap">
    <tr class="access">
        <td [attr.rowspan]="yap.accounts.length + 1">
            <button mat-icon-button (click)="removeYapAccess(yap)"><mat-icon color="warn">delete</mat-icon></button>
        </td>
        <td [attr.rowspan]="yap.accounts.length + 1">{{yap.institution}}</td>
        <td [attr.rowspan]="yap.accounts.length + 1">{{yap.createdAt | fromNow}}</td>
        <td [attr.rowspan]="yap.accounts.length + 1">{{yap.status}}</td>
        <td [attr.rowspan]="yap.accounts.length + 1">
            <button mat-icon-button (click)="refreshYapAccess(yap)" color="primary"
            matTooltip="Connect to bank to refresh authorization to access bank information. Authorization only lasts 90 days, needs to be refreshed using this button to continue access">
                <mat-icon>cached</mat-icon>
            </button>
        </td>
        <td [attr.rowspan]="yap.accounts.length + 1">
            <button mat-icon-button (click)="testYapAccess(yap)" color="primary"
            matTooltip="Test the connection to the bank account">
                <mat-icon>quiz</mat-icon>
            </button>
        </td>
    </tr>
    @for (yapAcct of yap.accounts; track $index) {
        <ng-container [ngTemplateOutlet]="yapAccountTemplate" [ngTemplateOutletContext]="{yapAcct, consentId: yap.consentId}"></ng-container>
    }
</ng-template>

<ng-template #yapAccountTemplate let-yapAcct="yapAcct" let-consentId="consentId">
    <tr class="access">
        <td matTooltip="The system account this authorization is connected to" style="min-width: 20em">
            @if (yapAcct.ourBankAccountName) {
                {{yapAcct.ourBankAccountName}}
            } @else {
                <select (change)="onYapAccountSelected($any($event.target).value, yapAcct, consentId)">
                    <option></option>
                    @for (b of bankAccounts; track $index) {
                        @if(!b.yapilyAccountId) {
                            <option [value]="b.id">
                                {{b.name}}
                            </option>
                        }
                    }
                </select>
            }
        </td>
        <td>{{yapAcct.type}}</td>
        <td>{{yapAcct.iban}}</td>
        <td>{{yapAcct.nickname}}</td>
        <td>{{yapAcct.holder}}</td>
    </tr>
</ng-template>
